import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prescripteur-select',
  templateUrl: './prescripteur-select.component.html',
  styleUrls: ['./prescripteur-select.component.scss']
})
export class PrescripteurSelectComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
